export const ADMIN = 'admin';
export const USER = 'user';
export const FAMILY_ADMIN = 'family_admin';